import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "d-flex flex-column min-vh-100" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("section", { class: "primary-gradient-bg text-center my-5 py-5" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "py-4" })
], -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("section", { class: "pb-5 contact-bg" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "container container-fluid" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "row" }, [
      /*#__PURE__*/_createElementVNode("div", {
        class: "col-md-6 offset-md-3 bg-white px-5 py-4 border rounded-2",
        style: {"margin-top":"-100px"}
      }, [
        /*#__PURE__*/_createElementVNode("h5", { class: "fw-bold text-center mb-4" }, "Send us a message"),
        /*#__PURE__*/_createElementVNode("form", null, [
          /*#__PURE__*/_createElementVNode("div", { class: "col-md-10 mb-5" }, [
            /*#__PURE__*/_createElementVNode("div", { class: "mb-4" }, [
              /*#__PURE__*/_createElementVNode("input", {
                type: "text",
                placeholder: "Full Name",
                class: "form-control material-control"
              })
            ]),
            /*#__PURE__*/_createElementVNode("div", { class: "mb-4" }, [
              /*#__PURE__*/_createElementVNode("input", {
                type: "email",
                placeholder: "Email Address",
                class: "form-control material-control"
              })
            ]),
            /*#__PURE__*/_createElementVNode("div", { class: "mb-4" }, [
              /*#__PURE__*/_createElementVNode("textarea", {
                placeholder: "Message",
                row: "3",
                class: "form-control material-control"
              })
            ])
          ]),
          /*#__PURE__*/_createElementVNode("div", { class: "w-100 text-center" }, [
            /*#__PURE__*/_createElementVNode("button", {
              type: "button",
              class: "btn btn-primary btn-sm rounded-5 px-5 me-2 fw-bold"
            }, "Send")
          ])
        ])
      ])
    ])
  ])
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Header = _resolveComponent("Header")!
  const _component_Footer = _resolveComponent("Footer")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_Header),
    _hoisted_2,
    _hoisted_3,
    _createVNode(_component_Footer)
  ]))
}